// import React from "react";
// import {
//   Page,
//   Text,
//   View,
//   Document,
//   StyleSheet,Image
// } from "@react-pdf/renderer";


// const styles = StyleSheet.create({
//   page: {
//     padding: 20,
//     fontSize: 10,
//      paddingTop: 80,
//   },
//   section: {
//     marginBottom: 10,

//   },
//   headerContainer: {
//     alignItems: "center",
//     justifyContent: "flex-start",
//     marginTop: 20,
//     marginBottom: 20
//   },
//   headerText: {
//     fontSize: 16,
//     fontWeight: "bold",
//     textAlign: "center",
//     marginBottom: 10
//   },
//   subHeaderText: {
//     fontSize: 10,
//     fontWeight: "bold",
//     //textAlign: "center",
//     marginBottom: 5
//   },
//   table: {
//     display: "table",
//     width: "100%",
//     borderWidth: 1,
//     borderColor: "#000",
//     borderStyle: "solid",
//     marginTop: 10
//   },
//   tableRow: {
//     flexDirection: "row",
//     borderBottomWidth: 1,
//     borderBottomColor: "#000",
//     borderBottomStyle: "solid",
//   },
//   tableRowLast: {
//     flexDirection: "row",
//   },
//   //   tableColHeader1: {
//   //     width: "20px",
//   //     borderRightWidth: 1,
//   //     borderRightColor: "#000",
//   //     padding: 5,
//   //     fontWeight: "bold",
//   //     backgroundColor: "#EEE",
//   //     justifyContent: "center",
//   //     alignItems: "center",
//   //     textAlign: "center",
//   //   },
//   //   tableCol1: {
//   //     width: "30px",
//   //     borderRightWidth: 1,
//   //     borderRightColor: "#000",
//   //     padding: 5,
//   //     justifyContent: "center",
//   //     alignItems: "center",
//   //     textAlign: "right",
//   //   },
//   //   tableColHeader: {
//   //     width: "100px",
//   //     flex: 1,
//   //     borderRightWidth: 1,
//   //     borderRightColor: "#000",
//   //     padding: 5,
//   //     fontWeight: "bold",
//   //     backgroundColor: "#EEE",
//   //     justifyContent: "center",
//   //     alignItems: "center",
//   //     textAlign: "center",
//   //   },
//   //   tableColHeaderDescription: {
//   //     width: "500px",
//   //     flex: 2.5,
//   //     borderRightWidth: 1,
//   //     borderRightColor: "#000",
//   //     padding: 5,
//   //     fontWeight: "bold",
//   //     backgroundColor: "#EEE",
//   //     justifyContent: "center",
//   //     alignItems: "center",
//   //     textAlign: "center",
//   //   },

//   //   tableCol: {
//   //     width: "100px",
//   //     flex: 1,
//   //     borderRightWidth: 1,
//   //     borderRightColor: "#000",
//   //     padding: 5,
//   //     justifyContent: "center",
//   //     alignItems: "center",
//   //     textAlign: "left",
//   //   },

//   //  tableColDescription: {
//   //   width: "500px",
//   //   flex: 2.5,
//   //   borderRightWidth: 1,
//   //   borderRightColor: "#000",
//   //   padding: 5,
//   //   textAlign: "left",       
//   //   alignItems: "flex-start",  
//   //   justifyContent: "center",  
//   // },

//   // tableColHeader1: {
//   //   width: "30px", // keep S.No column narrow
//   //   borderRightWidth: 1,
//   //   borderRightColor: "#000",
//   //   padding: 5,
//   //   fontWeight: "bold",
//   //   backgroundColor: "#EEE",
//   //   textAlign: "center",
//   // },
//   // tableCol1: {
//   //   width: "30px", // keep it narrow
//   //   borderRightWidth: 1,
//   //   borderRightColor: "#000",
//   //   padding: 5,
//   //   textAlign: "right",
//   // },
//   // tableColHeader: {
//   //   flex: 1, // Allow responsive layout
//   //   borderRightWidth: 1,
//   //   borderRightColor: "#000",
//   //   padding: 5,
//   //   fontWeight: "bold",
//   //   backgroundColor: "#EEE",
//   //   textAlign: "center",
//   // },
//   // tableColHeaderDescription: {
//   //   flex: 2.5, // Give more space to Description
//   //   borderRightWidth: 1,
//   //   borderRightColor: "#000",
//   //   padding: 5,
//   //   fontWeight: "bold",
//   //   backgroundColor: "#EEE",
//   //   textAlign: "center",
//   // },
//   // tableCol: {
//   //   flex: 1, // Responsive width for general cells
//   //   borderRightWidth: 1,
//   //   borderRightColor: "#000",
//   //   padding: 5,
//   //   textAlign: "left",
//   // },
//   // tableColDescription: {
//   //   flex: 2.5, // Give more space to Description
//   //   borderRightWidth: 1,
//   //   borderRightColor: "#000",
//   //   padding: 5,
//   //   textAlign: "left",
//   // },
//   tableColHeader1: {
//     width: 30,
//     borderRightWidth: 1,
//     borderRightColor: "#000",
//     padding: 5,
//     fontWeight: "bold",
//     backgroundColor: "#EEE",
//     textAlign: "center",
//   },
//   tableCol1: {
//     width: 30,
//     borderRightWidth: 1,
//     borderRightColor: "#000",
//     padding: 5,
//     textAlign: "right",
//   },
//   tableColHeader: {
//     width: 70,
//     borderRightWidth: 1,
//     borderRightColor: "#000",
//     padding: 5,
//     fontWeight: "bold",
//     backgroundColor: "#EEE",
//     textAlign: "center",
//   },
//    tableColApprDateHeader: {
//      width: 70,
//     // borderRightWidth: 1,
//     borderRightColor: "#000",
//     padding: 5,
//     fontWeight: "bold",
//     backgroundColor: "#EEE",
//     textAlign: "center",
//   },
//   tableColHeaderSmall: {
//     width: 70,
//     borderRightWidth: 1,
//     borderRightColor: "#000",
//     padding: 5,
//     fontWeight: "bold",
//     backgroundColor: "#EEE",
//     textAlign: "center",
//   },
//   tableColHeaderDescription: {
//     flex: 1,
//     borderRightWidth: 1,
//     borderRightColor: "#000",
//     padding: 5,
//     fontWeight: "bold",
//     backgroundColor: "#EEE",
//     textAlign: "center",
//   },
//   tableCol: {
//     width: 70,
//     borderRightWidth: 1,
//     borderRightColor: "#000",
//     padding: 5,
//     textAlign: "left",
//   },
//    tableColApprDate: {
//     width: 70,
//     // borderRightWidth: 1,
//     borderRightColor: "#000",
//     padding: 5,
//     textAlign: "left",
//   },
//   tableColSmall: {
//     width: 70,
//     borderRightWidth: 1,
//     borderRightColor: "#000",
//     padding: 5,
//     textAlign: "left",
//   },
//   // tableColDescription: {
//   //   flex: 1,
//   //   borderRightWidth: 1,
//   //   borderRightColor: "#000",
//   //   padding: 5,
//   //   textAlign: "left",
//   // },
//   tableColDescription: {
//     flex: 1,
//     borderRightWidth: 1,
//     borderRightColor: "#000",
//     padding: 5,
//     textAlign: "left",
//     flexWrap: "wrap",      
//     maxWidth: "100%"    
//   },

// /*Header*/
//   headerWrapper: {
//     position: "absolute",
//     top: 15,
//     left: 20,
//     right: 20,
//     height: 50,
//     justifyContent: "center",
//     alignItems: "center",
//   },
//   headerImage: {
//     width: "100%",
//     height: 60,
//     objectFit: "contain",
//   },


//  /* FOOTER */
//   footerWrapper: {
//     position: "absolute",
//     bottom: 25,
//     left: 5,
//     right: 5,
//     height: 80,
//     justifyContent: "center",
//     alignItems: "center",
//   },
//   footerImage: {
//     width: "100%",
//     height: 100,
//     objectFit: "cover",
//   },


// });

// // Split data: 20 on first page, 26 afterwards
// // const paginateData = (data) => {
// //   const firstPage = data.slice(0, 20);
// //   const otherPages = [];

// //   for (let i = 20; i < data.length; i += 20) {
// //     otherPages.push(data.slice(i, i + 20));
// //   }

// //   return [firstPage, ...otherPages];
// // };

// // const paginateData = (data) => {
// //   const pages = [];

// //   const firstPageCount = 7;
// //   const otherPageCount = 9;

// //   // 🔹 First page (8 rows)
// //   const firstPage = data.slice(0, firstPageCount).map((item, index) => ({
// //     ...item,
// //     SLNO: index + 1, // 1–8
// //   }));

// //   pages.push(firstPage);

// //   // 🔹 Remaining pages (10 rows each)
// //   let slCounter = firstPageCount + 1;

// //   for (let i = firstPageCount; i < data.length; i += otherPageCount) {
// //     const page = data.slice(i, i + otherPageCount).map((item) => ({
// //       ...item,
// //       SLNO: slCounter++, // continues globally
// //     }));

// //     pages.push(page);
// //   }

// //   return pages;
// // };


// const FIRST_PAGE_COUNT = 6;
// const OTHER_PAGE_COUNT = 7;

// const paginateData = (data) => {
//   const pages = [];

//   // First page
//   pages.push(data.slice(0, FIRST_PAGE_COUNT));

//   // Remaining pages
//   for (
//     let i = FIRST_PAGE_COUNT;
//     i < data.length;
//     i += OTHER_PAGE_COUNT
//   ) {
//     pages.push(data.slice(i, i + OTHER_PAGE_COUNT));
//   }

//   return pages;
// };
// // const paginateData = (data) => {
// //   const pages = [];

// //   for (let i = 0; i < data.length; i += 20) {
// //     const page = data.slice(i, i + 20).map((item, index) => ({
// //       ...item,
// //       SLNO: i + index + 1, // SLNO is global: 1, 2, ..., 21, 22, etc.
// //     }));
// //     pages.push(page);
// //   }

// //   return pages;
// // };

// //const TimeSheetreportpdf = ({ data = [], filters = {} }) => {
// const TimeSheetreportpdf = ({ data = [], filters = {}, projectName = "", managerName = "" }) => {
//   const pages = paginateData(data);
//   pages.forEach((page, i) => {
//     console.log(`Page ${i + 1} first row index:`, data.indexOf(page[0]));
//   });
//   const formatDate = (inputDate) => {
//     if (!inputDate) return "";
//     const [year, month, day] = inputDate.split("-");
//     return `${day}-${month}-${year}`;
//   };


//   const monthNames = [
//     "January", "February", "March", "April", "May", "June",
//     "July", "August", "September", "October", "November", "December"
//   ];
//   console.log(filters.EmployeeID, "EMP");
//   return (
//     <Document>
//       {pages.map((pageData, pageIndex) => (
//         <Page size="A4" orientation="landscape" style={styles.page} key={pageIndex}>
//          {/* /*Header*/ }
//           <View fixed style={styles.headerWrapper}>
//                      {filters.HeaderImg && (
//                        <Image
//                          src={`${filters.Imageurl}/uploads/images/${filters.HeaderImg}`}
//                          style={styles.headerImage}
//                        />
//                      )}
//                    </View>

//           {pageIndex === 0 && (
//             // <View style={styles.headerContainer}>
//             //   <Text style={styles.headerText}>

//             //     {`TimeSheet - ${filters.EmployeeID} (${monthNames[filters.Month - 1]} - ${filters.Year})`}
//             //   </Text>
//             // </View>
//             <View style={styles.headerTextContainer}>
//               <Text style={styles.headerText}>
//                 {`Timesheet - ${filters.EmployeeID} (${monthNames[filters.Month - 1]} - ${filters.Year})`}
//               </Text>
//               <Text style={styles.subHeaderText}>
//                 {`Project: ${projectName}`}
//               </Text>
//               {/* <Text style={styles.subHeaderText}>
//           {`Manager: ${managerName}`}
//         </Text> */}
//               {managerName !== "" && (
//                 <Text style={styles.subHeaderText}>
//                   {`Manager: ${managerName}`}
//                 </Text>
//               )}
//               <Text style={styles.subHeaderText}>
//                 {"Comp -> Completed ||Appr -> Approved"}
//               </Text>
//             </View>

//           )}

//           {/* Table Header */}
//           <View style={styles.table}>
//             <View style={styles.tableRow}>
//               <Text style={styles.tableColHeader1}>SL#</Text>
//               <Text style={styles.tableColHeader}>Date</Text>
//               <Text style={styles.tableColHeaderSmall}>Project</Text>
//               <Text style={styles.tableColHeaderDescription}>Task</Text>
//               <Text style={styles.tableColHeader1}>Hrs</Text>
//               <Text style={styles.tableColHeader}>Comp Date</Text>
//               <Text style={styles.tableColHeaderSmall}>Appr By</Text>
//               <Text style={styles.tableColApprDateHeader}>Appr Date</Text>
//             </View>

//             {pageData.map((row, rowIndex) => {
//                      const globalIndex =
//   pageIndex === 0
//     ? rowIndex + 1
//     : FIRST_PAGE_COUNT +
//       (pageIndex - 1) * OTHER_PAGE_COUNT +
//       rowIndex +
//       1;
//               const isLast = rowIndex === pageData.length - 1;
//               return (
//                 <View
//                   key={rowIndex}
//                   wrap={false} style={isLast ? styles.tableRowLast : styles.tableRow}
//                 >
//                   <Text style={styles.tableCol1}>{globalIndex}</Text>
//                   {/* <Text style={styles.tableCol1}>{rowIndex + 1}</Text> */}
//                   <Text style={styles.tableCol}>{row.DTDate}</Text>
//                   <Text style={styles.tableColSmall}>{row.ProjectCode}</Text>
//                   {/* <Text style={styles.tableColDescription}>{row.Description}</Text> */}
//                   <Text style={styles.tableColDescription}>
//                     {[row.Description?.trim(), row.Comments?.trim()]
//                       .filter(Boolean)
//                       .join(" || ")}
//                   </Text>
//                   <Text style={styles.tableCol1}>{row.ActualHourse}</Text>
//                   <Text style={styles.tableCol}>{row.CompletedDate?.split(" ")[0]}</Text>
//                   <Text style={styles.tableColSmall}>{row.ManagerCode}</Text>
//                   <Text style={styles.tableColApprDate}>{row.ApprovedDate}</Text>
//                 </View>
//               );
//             })}
//           </View>
//           <View
//             fixed
//             style={{
//               position: "absolute",
//               bottom: 10,
//               left: 0,
//               right: 0,
//               textAlign: "center",
//               fontSize: 10,
//             }}
//           >
//             <Text>Page {pageIndex + 1} of {pages.length}</Text>
//           </View>
// {/* /*Footer*/ }
//   <View fixed style={styles.footerWrapper}>
//             {filters.FooterImg && (
//               <Image
//                 src={`${filters.Imageurl}/uploads/images/${filters.FooterImg}`}
//                 style={styles.footerImage}
//               />
//             )}
//           </View>

//         </Page>
//       ))}
//     </Document>
//   );
// };

// export default TimeSheetreportpdf;
import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

// ─── PAGINATION CONFIG ────────────────────────────────────────────────────────
// Keep conservative — tall task text rows must never reach the footer band.
const FIRST_PAGE_COUNT = 7;   // first page has title block → fewer rows
const OTHER_PAGE_COUNT = 9;   // subsequent pages

const paginateData = (data) => {
  const pages = [];
  pages.push(data.slice(0, FIRST_PAGE_COUNT));
  for (let i = FIRST_PAGE_COUNT; i < data.length; i += OTHER_PAGE_COUNT) {
    pages.push(data.slice(i, i + OTHER_PAGE_COUNT));
  }
  return pages;
};

// ─── LAYOUT CONSTANTS ─────────────────────────────────────────────────────────
const HEADER_HEIGHT = 80;   // header image band height (px) — INCREASED for proper display
const FOOTER_HEIGHT = 90;   // footer image band height — generous to be safe
const PAGE_PADDING_H = 20;   // left / right padding

const styles = StyleSheet.create({
  page: {
    paddingLeft: PAGE_PADDING_H,
    paddingRight: PAGE_PADDING_H,
    paddingTop: HEADER_HEIGHT + 10,
    paddingBottom: FOOTER_HEIGHT + 18,
    fontSize: 9,
    fontFamily: "Helvetica",
  },

  // ── Header image band ─────────────────────────────────────────────────────
  headerWrapper: {
    position: "absolute",
    top: 15,
    left: 20,
    right: 20,
    height: 50,
    justifyContent: "center",
    alignItems: "center",
    overflow: "visible",
    display: "flex",
  },
  headerImage: {
    width: "100%",
    height: 60,
    objectFit: "contain",
  },

  footerWrapper: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: FOOTER_HEIGHT,
    overflow: "visible",
    display: "flex",
    alignItems: "center",
  },
  footerImage: {
    width: "100%",
    height: FOOTER_HEIGHT,
    objectFit: "cover",
  },

  pageNumber: {
    position: "absolute",
    bottom: FOOTER_HEIGHT + 4,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 9,
    color: "#444",
  },

  // ── Title block (first page only) ────────────────────────────────────────
  titleBlock: {
    marginBottom: 6,
  },
  headerText: {
    fontSize: 13,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 4,
  },
  subHeaderText: {
    fontSize: 9,
    fontWeight: "bold",
    marginBottom: 3,
  },

  // ── Table shell ───────────────────────────────────────────────────────────
  table: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#000",
    marginTop: 4,
  },

  tableHeaderRow: {
    flexDirection: "row",
    backgroundColor: "#EEE",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },

  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  tableRowLast: {
    flexDirection: "row",
  },

  // ── Column styles ─────────────────────────────────────────────────────────
  colSl: {
    width: 24, padding: 4,
    borderRightWidth: 1, borderRightColor: "#000",
    textAlign: "center",
  },
  colDate: {
    width: 62, padding: 4,
    borderRightWidth: 1, borderRightColor: "#000",
    textAlign: "left",
  },
  colProject: {
    width: 48, padding: 4,
    borderRightWidth: 1, borderRightColor: "#000",
    textAlign: "left",
  },
  colTask: {
    flex: 1, padding: 4,
    borderRightWidth: 1, borderRightColor: "#000",
    textAlign: "left",
  },
  colHrs: {
    width: 26, padding: 4,
    borderRightWidth: 1, borderRightColor: "#000",
    textAlign: "right",
  },
  colCompDate: {
    width: 62, padding: 4,
    borderRightWidth: 1, borderRightColor: "#000",
    textAlign: "left",
  },
  colApprBy: {
    width: 44, padding: 4,
    borderRightWidth: 1, borderRightColor: "#000",
    textAlign: "left",
  },
  colApprDate: {
    width: 58, padding: 4,
    // last column — no right border (table border covers it)
    textAlign: "left",
  },

  hdrText: { fontSize: 9, fontWeight: "bold" },
  cellText: { fontSize: 8 },
});

// ─── COMPONENT ────────────────────────────────────────────────────────────────
const TimeSheetreportpdf = ({
  data = [],
  filters = {},
  projectName = "",
  managerName = "",
  footerHeight
}) => {
  const pages = paginateData(data);

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];

  const headerSrc = filters.HeaderImg
    ? `${filters.Imageurl}/uploads/images/${filters.HeaderImg}`
    : null;

  const footerSrc = filters.FooterImg
    ? `${filters.Imageurl}/uploads/images/${filters.FooterImg}`
    : null;

  return (
    <Document>
      {pages.map((pageData, pageIndex) => (
        <Page
          key={pageIndex}
          size="A4"
          orientation="landscape"
          // style={styles.page}
          style={{
            // paddingBottom: 36,
            paddingBottom: footerHeight,
            paddingLeft: PAGE_PADDING_H,
            paddingRight: PAGE_PADDING_H,
            paddingTop: HEADER_HEIGHT + 10,
            fontSize: 9,
            fontFamily: "Helvetica",
          }}
        >
          {/* ── HEADER IMAGE (fixed — repeats on every page) ── */}
          {headerSrc && (
            <View fixed style={styles.headerWrapper}>
              <Image src={headerSrc} style={styles.headerImage} />
            </View>
          )}

          {/* ── TITLE BLOCK (first page only) ── */}
          {pageIndex === 0 && (
            <View style={styles.titleBlock}>
              <Text style={styles.headerText}>
                {`Timesheet - ${filters.EmployeeID} (${monthNames[(filters.Month ?? 1) - 1]
                  } - ${filters.Year})`}
              </Text>
              {!!projectName && (
                <Text style={styles.subHeaderText}>{`Project: ${projectName}`}</Text>
              )}
              {!!managerName && (
                <Text style={styles.subHeaderText}>{`Manager: ${managerName}`}</Text>
              )}
              <Text style={styles.subHeaderText}>
                {"Comp -> Completed  ||  Appr -> Approved"}
              </Text>
            </View>
          )}

          {/* ── TABLE ── */}
          <View style={styles.table}>

            {/* Header row */}
            <View style={styles.tableHeaderRow}>
              <Text style={[styles.colSl, styles.hdrText]}>SL#</Text>
              <Text style={[styles.colDate, styles.hdrText]}>Date</Text>
              <Text style={[styles.colProject, styles.hdrText]}>Project</Text>
              <Text style={[styles.colTask, styles.hdrText]}>Task</Text>
              <Text style={[styles.colHrs, styles.hdrText]}>Hrs</Text>
              <Text style={[styles.colCompDate, styles.hdrText]}>Comp Date</Text>
              <Text style={[styles.colApprBy, styles.hdrText]}>Appr By</Text>
              <Text style={[styles.colApprDate, styles.hdrText]}>Appr Date</Text>
            </View>

            {/* Data rows */}
            {pageData.map((row, rowIndex) => {
              const globalIndex =
                pageIndex === 0
                  ? rowIndex + 1
                  : FIRST_PAGE_COUNT +
                  (pageIndex - 1) * OTHER_PAGE_COUNT +
                  rowIndex + 1;

              const isLast = rowIndex === pageData.length - 1;
              const taskText = [row.Description?.trim(), row.Comments?.trim()]
                .filter(Boolean)
                .join(" || ");

              return (
                // wrap={false} — never split this row across pages.
                // If it doesn't fit, the whole row moves to the next page.
                <View
                  key={rowIndex}
                  wrap={false}
                  style={isLast ? styles.tableRowLast : styles.tableRow}
                >
                  <Text style={[styles.colSl, styles.cellText]}>{globalIndex}</Text>
                  <Text style={[styles.colDate, styles.cellText]}>{row.DTDate}</Text>
                  <Text style={[styles.colProject, styles.cellText]}>{row.ProjectCode}</Text>
                  <Text style={[styles.colTask, styles.cellText]}>{taskText}</Text>
                  <Text style={[styles.colHrs, styles.cellText]}>{row.ActualHourse}</Text>
                  <Text style={[styles.colCompDate, styles.cellText]}>
                    {row.CompletedDate?.split(" ")[0] ?? ""}
                  </Text>
                  <Text style={[styles.colApprBy, styles.cellText]}>{row.ManagerCode}</Text>
                  <Text style={[styles.colApprDate, styles.cellText]}>{row.ApprovedDate}</Text>
                </View>
              );
            })}
          </View>



          {/* ── FOOTER IMAGE (fixed — repeats on every page) ── */}
          {footerSrc && (
            <View fixed
              // style={styles.footerWrapper}
              style={{
                position: "absolute",
                bottom: 20,
                left: 0,
                right: 0,
                height: footerHeight, // 🔥 dynamic
              }}
            >
              <Image src={footerSrc}
                // style={styles.footerImage} 
                style={{
                  width: "100%",
                  height: "100%",
                }}
              />
            </View>
          )}
          {/* ── PAGE NUMBER ── */}
          <View fixed
            // style={styles.pageNumber}
            style={{
              position: "absolute",
              bottom: 5,
              left: 0,
              right: 0,
              textAlign: "center",
              fontSize: 9,
              color: "#444",
            }}
          >
            <Text>Page {pageIndex + 1} of {pages.length}</Text>
          </View>

        </Page>
      ))}
    </Document>
  );
};

export default TimeSheetreportpdf;

